import { render, staticRenderFns } from "./paymentInsuredDetails.vue?vue&type=template&id=32f05022&scoped=true"
import script from "./paymentInsuredDetails.vue?vue&type=script&lang=js"
export * from "./paymentInsuredDetails.vue?vue&type=script&lang=js"
import style0 from "./paymentInsuredDetails.vue?vue&type=style&index=0&id=32f05022&prod&lang=css"
import style1 from "./paymentInsuredDetails.vue?vue&type=style&index=1&id=32f05022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f05022",
  null
  
)

export default component.exports